// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"46e0702b","212":"8175c7f9","283":"48f8d0ba","631":"53b4cf27","821":"b1780cae"}[chunkId] + ".chunk.js";
};